import { render, staticRenderFns } from "./attorney-power-of-attorney-received.vue?vue&type=template&id=05595c90"
import script from "./attorney-power-of-attorney-received.vue?vue&type=script&lang=js"
export * from "./attorney-power-of-attorney-received.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports